/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useMutation } from '@tanstack/react-query';
import { Alert, Flex, Spin } from 'antd';
import AuthApi from 'apis/AuthApi';
import { Backgroud_LOGIN, LOGO_LOGIN } from 'assets/svg';
import { useUser } from 'contexts/UserProvider';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import path from 'routes/Path';
import { parseParams } from 'utils/constants/getQueryString';
import { getSignoutUri } from 'utils/constants/getSignoutUri';

const SignInPage = (): JSX.Element => {
  const { getUser } = useUser();

  const navigate = useNavigate();

  const query: any = parseParams(window.location.search);

  useEffect(() => {
    if (localStorage.getItem('token')) {
      navigate(`${path.ROOT}`);
    }
    if (!query.code) return;
    signin(query.code);
  }, [query.code]);

  const { mutate: signin, isPending } = useMutation({
    mutationFn: AuthApi.signIn,
    onSuccess: (data) => {
      localStorage.setItem('token', data.token);
      getUser();
      navigate(`${path.ROOT}`);
    },
    onError: (error: any) => {
      localStorage.removeItem('token');
      const logout_uri = getSignoutUri();
      window.location.replace(logout_uri);
      navigate(`${path.ROOT}`);
    },
  });

  const onSubmit = async () => {
    window.location.replace(process.env.REACT_APP_AWS_COGNITO_LOGIN as string);
  };
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
      }}
    >
      <Spin size="large" spinning={isPending}>
        <Backgroud_LOGIN className="fixed right-0 bottom-0" />
        <Flex
          vertical
          gap={25}
          className="fixed top-[10%] left-[7%]"
          align="center"
        >
          <LOGO_LOGIN className="mx-10" />
          <button
            className="py-3 font-bold text-white bg-main w-full rounded-xl"
            onClick={onSubmit}
          >
            Đăng nhập
          </button>
        </Flex>
      </Spin>
    </div>
  );
};

export default SignInPage;
